import githubIcon from '../images/url-icon/github-icon.png'
import linkedinIcon from '../images/url-icon/linkedin-icon.png'
import tstoryIcon from '../images/url-icon/tstory-icon.png'

export const channels = [
    {
        url: 'https://github.com/jinkyumpark',
        icon: githubIcon,
        border: false,
    },
    {
        url: 'https://jinkpark.tistory.com',
        icon: tstoryIcon,
        border: true,
    },
    {
        url: 'https://www.linkedin.com/in/jinkyumpark',
        icon: linkedinIcon,
        border: false,
    },
]
